<mat-menu #menu="matMenu" class="munily-dropdown-menu">
  <button
    *ngFor="let opt of options; trackBy: trackByOptionId"
    mat-menu-item
    type="button"
    class="munily-dropdown-menu__item"
    [class.munily-dropdown-menu__item--selected]="isSelected(opt)"
    [class.munily-dropdown-menu__item--no-leading-icon]="leadingIconMode === 'none'"
    [disabled]="!!opt.disabled"
    (click)="onSelect(opt)"
  >
    <mat-icon
      *ngIf="leadingIconLigature(opt) as icon"
      class="munily-dropdown-menu__leading-icon material-icons-outlined"
      aria-hidden="true"
    >
      {{ icon }}
    </mat-icon>

    <span class="munily-dropdown-menu__labels">
      <span class="munily-dropdown-menu__label">{{ opt.label }}</span>
      <span *ngIf="opt.description" class="munily-dropdown-menu__description">{{ opt.description }}</span>
    </span>
  </button>
</mat-menu>

